import React from "react";
import { Link } from "react-router-dom";
import FailedPayment from "../../assets/img/payment/Failed-Payment.png";

export default function Failed() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center text-center">
      <div className="w-100" style={{ maxWidth: "396px" }}>
        <img src={FailedPayment} alt="root-billing" className="img-fluid" />
      </div>
      <div className="mt-4 p-1">
        <h1 className="fw-bold">Payment was not Successful</h1>
        <p
          className="text-secondary"
          style={{ maxWidth: "70%", margin: "0 auto" }}
        >
          Please try again at a later stage.
        </p>
        <Link to="/dashboard" className="btn btn-primary mt-4">
          Try Again
        </Link>
      </div>
    </div>
  );
}
